export const toGlobalId = (nodeName: string, nodeId: string) => btoa(`${nodeName}:${nodeId}`);

export const toMongoId = (globalId: string) => atob(globalId).split(":")[1];
